<template>
  <section
    id="share"
    :style="[windowSize > 768 ? { backgroundImage: 'url(' + prismic_data.share_background_image.url + ')' } : { backgroundImage: 'url(' + prismic_data.share_background_image_mobile.url + ')' }, {backgroundColor: prismic_data.share_background_color}]"
  >
    <div class="container w-80">
      <div class="inner">
        <h2>{{prismic_data.share_title[0].text}}</h2>
        <p
          v-for="(intro_text, index) in prismic_data.share_intro_text"
          v-bind:key="index"
        >{{intro_text.text}}</p>
        <p class="quote">
          <span class="open">
            <img src="../assets/img/icon-quote.png" alt />
          </span>
          {{prismic_data.share_quote[0].text}}
          <span class="close">
            <img src="../assets/img/icon-quote-end.png" alt />
          </span>
        </p>
        <button class="button-primary" v-scroll-to="'#meme-generator'">{{prismic_data.share_button_text}}</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ShareSection",
  props: {
    prismic_data: {
      type: Object,
      required: true,
    },
    windowSize: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#share {
  background-position: center 50px;
  background-repeat: no-repeat;
  padding-top: 85px;
  padding-bottom: 96px;
  margin-top: 133px;
  background-size: 1290px;
  @media (max-width: $breakpoint-xl) {
    background-size: 93%;
  }

  @media (max-width: $breakpoint-sm) {
    padding-top: 180px;
    padding-bottom: 53px;
    background-size: initial;
  }

  .inner {
    padding: 0 168px;
    margin: 0 auto;
    @media (max-width: $breakpoint-md) {
      padding: 0 70px;
    }
    @media (max-width: $breakpoint-sm) {
      padding: 0 24px;
    }
    h2 {
      color: $color-dark-blue;
      line-height: 53px;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 44px;
      @media (max-width: $breakpoint-sm) {
        line-height: 47px;
        margin-bottom: 26px;
      }
    }

    p {
      line-height: 32px;
      text-align: center;
      &.quote {
        position: relative;
        font-family: $font-secondary;
        margin: 0 auto;
        margin-top: 77px;
        padding: 20px 32px;
        font-size: 36px;
        line-height: 52px;
        color: #333333;
        @media (max-width: $breakpoint-sm) {
          font-size: 24px;
          line-height: 40px;
          padding: 20px 15px;
          margin-top: 50px;
        }
      }
    }

    span {
      position: absolute;
      &.open {
        left: -12px;
        top: 0;
        @media (max-width: $breakpoint-sm) {
          left: 0;
          top: 0;
        }
      }

      &.close {
        bottom: -12px;
        right: -12px;
        @media (max-width: $breakpoint-sm) {
          bottom: 0;
          right: 0;
        }
      }
      img {
        @media (max-width: $breakpoint-sm) {
          width: 16px;
        }
      }
    }
  }

  .button-primary {
    padding: 13px 50px;
    margin: 0 auto;
    margin-top: 20px;
    line-height: 19px;
    @media (max-width: $breakpoint-sm) {
      padding: 10px 35px;
      margin-top: 50px;
    }
  }
}
</style>